import { Hidden } from '@material-ui/core';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { useLocalStorageState } from '../../../../../global/hooks/useLocalStorageState';
import { QuickActionItem, QuickActionsStorageKey } from '../../../../../global/models/quick-actions-model';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { useDeserializedToken } from '../../../components/use-deserialized-token';
import { useRoleObject } from '../../../components/useRoles';
import { MapPortalProps } from '../../../models/arc-epi-props';
import { FilterDefaultActionsByRoles, filterRemovedActions, getAllQuickActions, getCombinedGroups, getDefaultActionsByRole } from '../quick-action-helpers';
import { QuickActionSearch } from './quick-action-search';
import { QuickActionsAddRemove } from './quick-actions-add-remove';
import { QuickActionsReorder } from './quick-actions-reorder';

export function PortalQuickActions() {
    const portalProps = useSelector<TcsmStates, MapPortalProps>(state => state.epiProps?.mapPortalSettingsState?.epiContent);



    const [searchModalOpen, setSearchModalOpen] = useState(false);
    const [addRemoveModalOpen, setAddRemoveModalOpen] = useState(false);
    const [reordering, setReordering] = useState(false);
    const token = useDeserializedToken();
    const roles = useRoleObject();
    const roleNames = useSelector<TcsmStates, string[]>(state => state.authenticatedState.roles);
    const defaultQuickActions = FilterDefaultActionsByRoles(getDefaultActionsByRole(portalProps?.defaultQuickActions, roles), roleNames);
    const allQuickActions = getAllQuickActions(defaultQuickActions, portalProps?.quickActions, roles);
    const combinedGroups = getCombinedGroups(defaultQuickActions, portalProps?.quickActions, roles);

    const localStorageKey = `${QuickActionsStorageKey}_${token?.person?.guid}`;

    const [savedQuickActions, setQuickActions] = useLocalStorageState<QuickActionItem[]>(defaultQuickActions, localStorageKey);

    const selectedQuickActions = filterRemovedActions(savedQuickActions, allQuickActions);

    const onReorderingClick = () => {
        setReordering(true);
    };

    const saveQuickActions = (items: QuickActionItem[]) => {
        localStorage.setItem(localStorageKey, JSON.stringify(items));
        setQuickActions(items);
    };

    return (
        <DividerSection removeDivider>
            <div>
                <div className='quick-action-header'>
                    <h2>{portalProps?.quickActionsHeader}</h2>
                    <div className='quick-action-utility'>
                        <button
                            type='button'
                            className='quick-action-utility-button quick-action-utility-button-search'
                            onClick={() => setSearchModalOpen(true)}>
                            <svg className='icon' aria-hidden='true' focusable='false'>
                                <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#search-icon' />
                            </svg>
                            {portalProps?.searchQuickActionsPrompt}
                        </button>
                        <Hidden xsDown>
                            <button
                                type='button'
                                className='quick-action-utility-button'
                                onClick={() => setAddRemoveModalOpen(true)}>
                                <svg className='icon' aria-hidden='true' focusable='false'>
                                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#add-remove-icon' />
                                </svg>
                                {portalProps?.addOrRemoveActionsPrompt}
                            </button>
                            <button
                                type='button'
                                className='quick-action-utility-button'
                                onClick={onReorderingClick}
                                disabled={reordering}                        >
                                <svg className='icon' aria-hidden='true' focusable='false'>
                                    <use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#reorder-icon' />
                                </svg>
                                {portalProps?.reorderActionsPrompt}
                            </button>
                        </Hidden>
                    </div>
                </div>
            </div>
            <QuickActionSearch
                open={searchModalOpen}
                portalProps={portalProps}
                setSearchModalOpen={setSearchModalOpen}
                allQuickActions={allQuickActions}
            />

            <QuickActionsAddRemove
                open={addRemoveModalOpen}
                setModalOpen={setAddRemoveModalOpen}
                portalProps={portalProps}
                selectedQuickActions={selectedQuickActions}
                quickActionGroups={combinedGroups}
                allQuickActions={allQuickActions}
                setQuickActions={saveQuickActions}
            />


            <QuickActionsReorder
                setQuickActions={saveQuickActions}
                reordering={reordering}
                setReordering={setReordering}
                selectedQuickActions={selectedQuickActions}
                portalProps={portalProps}
            />
        </DividerSection>
    );
}